export const ASIDE_WIDTH = 256;
export const ASIDE_MIN_WIDTH = 58;
export const HEADER_HEIGHT = 60;
export const URL_PARAM_NAME = 'name';
export const ASIDE_ITEM_HEIGHT = 56;
